import type {ReactNode} from "react";

export default class ReactNodeError extends Error {
    public reactNode: ReactNode;

    constructor(reactNode: ReactNode, message?: string) {
        super(message);

        this.reactNode = reactNode;
    }
}